export class ReconciliationSearchDTO{
  public vendor_code?:string
  public ty?:string
  public doc_no?:string
  public post_date?:string
  public bill_no?:string
  public bill_date?:string
  public assignment?:string
  public debit?:string
  public credit?:string
  public balance?:string
  public description?:string
}
